import { Portfolio } from '@components/portfolio/Portfolio';
import { RoutePaths } from '@enums/RoutePaths';
import { useUserDealer } from '@hooks/UseUserDealer';
import { setDealsheetMvo } from '@store/essential-ui/mvoUI/MvoUiSlice';
import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

const PortfolioPage: FC = () => {
  const { dealType } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isIncentiveAdvantageType } = useUserDealer();

  if (isIncentiveAdvantageType) {
    navigate(RoutePaths.EssentialDashboard);
  }

  useEffect(() => {
    dispatch(setDealsheetMvo(1));

    const portfolioNav = { state: 'app.portfolio', route: dealType };
    localStorage.setItem('lastNavigation', JSON.stringify(portfolioNav));
  }, [dealType]);

  return <Portfolio />;
};

export default PortfolioPage;
